module.exports = __webpack_public_path__ + "static/media/PF-1030Sumidero.7617034c.jpg";